import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const Mentions = () => {
  return (
			<div>
				<Header></Header>
				<br />
				<br />
				<br />
				<div class='row  mx-auto  p-5'>
					<div class='card  bg-gradient border-danger border-5' style={{ backgroundColor: '#003300' }}>
						<div class='card-body text-white'>
							<h1 class='card-title text-center'>MENTIONS LÉGALES</h1>
							<br/>
							<p class='card-text text-start'>
								<h2>Éditeur du site</h2>
								<br/>
								Le présent site internet epavistemoro.fr est édité par :<br />
								EPAVISTE MORO
								<br />
								Immatriculée au Registre du Commerce et des Sociétés de Bayonne sous le numéro 804 689 073
								<br />
								Adresse : Résidence Lehena, 521 Route d'Arcangues, 64200 Bassussarry, France
								<br />
								Responsable de la publication : Le dirigeant de la société EPAVISTE MORO
								<br />
								Email : epavistemoro@gmail.com
								<br />
								Téléphone : 06 18 76 79 35
								<br/>
								<br/>
								<h2>Hébergement</h2><br/>Le site est hébergé par : Netlify, Inc.
								<br />
								44 Montgomery Street, Suite 300
								<br />
								San Francisco, California 94104
								<br />
								USA
								<br />
								Site web : www.netlify.com 
								<br/>
								<br/>
								<h2>Propriété intellectuelle</h2>
								<br/>
								L’ensemble du contenu présent sur le site epavistemoro.fr (textes, images, graphismes, logo, icônes, etc.) est protégé par le droit de la
								propriété intellectuelle.
								<br />
								Toute reproduction, représentation, modification, publication, transmission ou adaptation de tout ou partie du site, quel que soit le moyen ou
								le procédé utilisé, est interdite sans autorisation écrite préalable.
								<br />
								Toute exploitation non autorisée du site ou de son contenu sera considérée comme constitutive d’une contrefaçon et pourra faire l’objet de
								poursuites.
							</p>
							<br/>
							<h1 class='card-title text-center'>MENTION SPÉCIFIQUE ACTIVITÉ ÉPAVISTE</h1>
							<br/>
							<p class='card-text'>
								Conformément à la réglementation en vigueur, l’enlèvement et la destruction des véhicules hors d’usage (VHU) sont réalisés via des centres
								agréés.
								<br />
								L’utilisateur s’engage à fournir des informations exactes concernant le véhicule et à être en mesure de justifier de sa propriété (carte
								grise, pièce d’identité).
								<br />
								EPAVISTE MORO se réserve le droit de refuser toute intervention ne respectant pas la réglementation en vigueur.
							</p>
						</div>
					</div>
				</div>
				<br />
				<br />
				<br />
				<br />
				<Footer></Footer>
			</div>
		);
};

export default Mentions;
